import * as React from "react";
import * as ReactDOM from "react-dom";
import {resourceStrings} from "./Strings";
import isInFrame from "../Utils/InFrame";

export enum NavLinks {
    root,
    mybots,
    register,
    docs,
    directory,
    blog,
    admin,
    reviewbots
}

export interface JumboHeadProps extends React.Props<JumboHeadControl> {
    navLinks: string[];
    rootUrl: string;
    defaultLink: NavLinks;
    isRoutable: (url: string) => boolean;
    showFrame?: boolean;
    className?: string;
}

export interface JumboHeadState {
    activeLink?: NavLinks
}

//these should be kept in sync with the NavLinks enumeration
const navLinkNames = ['', 'My bots', 'Register a bot', 'Documentation', resourceStrings.botDirectory, 'Blog'];

export function getLinkDisplayText(navLink: NavLinks): string {
    return navLinkNames[navLink];
}

export function normalizeExternalRouteUrl(root: string, route: string) : string {
    if (root && root.length) {
        if (root.charAt(root.length - 1) !== '/') {
            return `${root}/${route}`;
        } else {
            return `${root}${route}`;
        }
    }
    return route;
}

export class JumboHeadControl extends React.Component<JumboHeadProps, JumboHeadState> {        
    constructor(props: JumboHeadProps) {
        super(props);
        this.state = { activeLink: props.defaultLink };
    }

    private toggleNavList() {
        $(ReactDOM.findDOMNode(this.refs['navList'])).toggleClass('expand');
    }

    public render(): JSX.Element {
        if (!this.props.showFrame && isInFrame()) {
            return null;
        }
        let rootUrlClassName = this.props.isRoutable(this.props.rootUrl) ? "appnav" : null;
        return (
            <div className={`brand-primary ${this.props.className ||''}`}>
                <div className="jumbo">
                    <div className="jumbo-header"><a href={this.props.rootUrl} className={rootUrlClassName}>{resourceStrings.botFramework}</a></div>
                    <ul ref="navList" className="header-nav" onClick={_.debounce(_.bind(this.toggleNavList, this), 200, true)}>
                        {this.props.navLinks.map((href, link) => {
                            var linkEnum = link + 1;
                            var activeLink = this.state.activeLink;
                            if (_.isUndefined(activeLink)) {
                                activeLink = this.props.defaultLink;
                            }
                            var className = linkEnum === activeLink ? "active" : null;
                            var linkClassName = this.props.isRoutable(href) ? "appnav" : null;
                            return (<li key={navLinkNames[linkEnum]} className={className}><a href={href} className={linkClassName}>{navLinkNames[linkEnum]}</a></li>);
                        })}
                    </ul>
                    {this.props.children}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./../Intercom.ReactUI/Views/JumboHeadControl.tsx